import * as React from "react";
import { toast } from "sonner";

import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";

type HealthResponse = {
  ok: boolean;
  baseUrl?: string;
  wpJsonUrl?: string;
  public?: {
    ok: boolean;
    status: number;
    error?: string;
    site?: {
      name?: string;
      description?: string;
      namespaces?: string[];
    } | null;
  };
  auth?: {
    configured: boolean;
    ok?: boolean;
    status?: number;
    error?: string;
    details?: {
      code?: string;
      message?: string;
    } | null;
    user?: {
      id?: number;
      name?: string;
      slug?: string;
    } | null;
  };
};

export function WordpressConnectionTest() {
  const [loading, setLoading] = React.useState(false);
  const [result, setResult] = React.useState<HealthResponse | null>(null);

  const runTest = async () => {
    setLoading(true);
    try {
      const res = await fetch("/api/wp/health");
      const json = (await res.json()) as HealthResponse;
      setResult(json);

      if (json.ok) {
        toast.success("WordPress bağlantısı OK", {
          description: json.public?.site?.name ?? json.baseUrl,
        });
      } else if (json.public?.ok && json.auth?.configured && json.auth.ok === false) {
        toast.error("WordPress giriş bilgileri hatalı", {
          description:
            json.auth.details?.code ??
            json.auth.error ??
            `HTTP ${json.auth.status ?? 0}`,
        });
      } else {
        toast.error("WordPress bağlantısı başarısız", {
          description:
            json.public?.error ?? json.auth?.error ?? "Bağlantı doğrulanamadı",
        });
      }
    } catch (error) {
      toast.error("WordPress bağlantısı başarısız", {
        description: error instanceof Error ? error.message : "Bilinmeyen hata",
      });
      setResult({
        ok: false,
        public: { ok: false, status: 0, error: "İstek başarısız" },
        auth: { configured: false },
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card>
      <CardHeader className="space-y-2">
        <CardTitle className="text-base">Bağlantı testi</CardTitle>
        <CardDescription>
          Sunucu üzerinden WordPress REST API (Basic Auth) erişimini dener.
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <Button
          type="button"
          variant="outline"
          className="rounded-full"
          onClick={runTest}
          disabled={loading}
        >
          {loading ? "Kontrol ediliyor..." : "Test et"}
        </Button>

        {result && (
          <pre className="overflow-auto rounded-2xl border bg-muted p-4 text-xs leading-relaxed text-muted-foreground">
            {JSON.stringify(result, null, 2)}
          </pre>
        )}
      </CardContent>
    </Card>
  );
}
